import { ProductPageLayout } from '../components/ProductPageLayout';

export function OutfitSwapBuilderPage() {
    return <ProductPageLayout productId="outfit-swap-builder" />;
}
